module.exports = __webpack_public_path__ + "img/19.ca33fdb7.jpeg";